import { AxiosInstance, AxiosError } from 'axios';
import { useEffect } from 'react';
import { useCaptchaControl } from '../../providers/CaptchaControlProvider.tsx';
import { RECAPTCHA_VERSION_HEADER } from '../../constants/config.ts';
import { ReCaptchaVersions } from '../../constants/entities.ts';

const IS_DEV = import.meta.env.DEV;

const useAxiosCaptchaSetup = (instance: AxiosInstance) => {
  const { increaseRequestFailedCount, setFailedV3 } = useCaptchaControl();

  useEffect(() => {
    instance.interceptors.response.use(
      (res) => res,
      async (err: unknown) => {
        // Handle captcha-specific errors
        if (!IS_DEV && err instanceof AxiosError && err.response?.status === 422) {
          const requestUrl = err.response.config.url;
          if (requestUrl) {
            increaseRequestFailedCount(requestUrl);

            if (err.config?.headers[RECAPTCHA_VERSION_HEADER] === ReCaptchaVersions.V3) {
              setFailedV3(requestUrl);
            }
          }
        }

        // Ensure we're rejecting with an Error object
        if (err instanceof Error) {
          return Promise.reject(err);
        }
        // Convert unknown errors to Error objects
        const errorMessage = err instanceof Object ? JSON.stringify(err) : String(err);
        return Promise.reject(new Error(errorMessage));
      },
    );
  }, [increaseRequestFailedCount, setFailedV3]);
};

export default useAxiosCaptchaSetup;
